import { Translation } from "../../hooks/useTranslations";
import { Entity, Version } from "../../types";
import { Car } from "../cars/types";

export type AssignmentType = "not-in-use" | "car-pool";

export type OtherCarAssignment = Entity & {
  id: string;
  car: Car;
  startDate: string;
  endDate?: string;
  type: AssignmentType;
  costCenter: string;
};

export type OtherCarAssignmentVersion = Version & {
  id: string;
  startDate: string;
  endDate?: string;
  type: string;
  costCenter: string;
};

export type UpsertOtherCarAssignment = {
  carId: string;
  startDate: string;
  endDate?: string;
  prevEndDate?: string;
  currentVersionNumber?: number;
  type: string;
  costCenter: string;
};

export type CarAssignmentType = {
  value: AssignmentType;
  label: string;
};

export const getAssignmentTypes = (i18n: Translation): CarAssignmentType[] => [
  { value: "not-in-use", label: i18n.common.notInUse },
  { value: "car-pool", label: i18n.common.carPool },
];
